import { OPEN_MODAL } from '../../utils/constantes'

export default function openModal () {
    return{
        type: OPEN_MODAL,
    }
}